import { Typography } from '@smartgift/frontend-toolkit';
import styled from 'styled-components';

const TagArea = styled.div`
  align-items: center;
  background: var(--color-accent-primary-weakest);
  color: var(--color-components-button-primary-contained-bg);
  display: flex;
  justify-content: center;
  padding: 0 4px;
`;

const DropdownItem = styled(Typography)`
  color: var(--color-accent-primary-strongest);
  padding: 4px 8px;
  white-space: nowrap;

  &:hover {
    background-color: var(--color-components-button-primary-contained-fg);
  }
`;

const TagAreaBody = styled.div`
  align-items: center;
  background: var(----color-components-button-primary-contained-bg);
  border-radius: var(--size-border-radius-md);
  cursor: pointer;
  display: flex;
  font-size: 12px;
  gap: 4px;
  line-height: 150%;
  padding: 4px 0px;
  position: relative;
`;

const TagAreaDropdown = styled.div`
  background: var(--color-accent-primary-weaker);
  bottom: 25px;
  position: absolute;
  width: fit-content;
  z-index: 9;
`;

export { DropdownItem, TagArea, TagAreaBody, TagAreaDropdown };
